import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { BREAKPOINTS } from '../utilities/index';

(function () {
  'use strict';

  // class Slider //========//
  class Slider {
    constructor(wrap, reverse) {
      this.wrap = wrap;
      this.reverse = reverse;
      this.list = this.wrap.querySelector('.swiper-wrapper');
      this.swiper = null;
      this.startFlag = false;
    }

    resize(play) {
      //console.log('slider resize');
      // swiper destroy
      this.removeSlide();

      // 追加した要素削除
      this.wrap.querySelectorAll('.clone').forEach((elm) => {
        elm.remove();
      });

      // 横いっぱいに複製して埋める
      const slide = this.wrap.querySelectorAll('.swiper-slide');
      let w = 0;
      slide.forEach((s) => {
        w += s.clientWidth;
      });
      const add = Math.ceil(window.innerWidth / w);
      for (let i = 1; i <= add; i++) {
        slide.forEach((s) => {
          const clone = s.cloneNode(true);
          clone.classList.add('clone');
          this.list.appendChild(clone);
        });
      }

      // swiper
      this.setSlide(play);
    }

    removeSlide() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }

    stopAutoplay() {
      //console.log('stopAutoplay');
      if (this.startFlag) {
        this.startFlag = false;
      }
      // Stop slide at current translate.
      this.swiper.setTranslate(this.swiper.getTranslate());

      // Calculating the distance between current slide and next slide.
      // 0.3 is equal to 30% distance to the next slide.
      const currentSlideWidth = this.swiper.slides[this.swiper.activeIndex].offsetWidth;
      this.distanceRatio = Math.abs((currentSlideWidth * this.swiper.activeIndex + this.swiper.getTranslate()) / currentSlideWidth);

      // The duration that playing to the next slide
      this.duration = this.swiper.params.speed * this.distanceRatio;

      this.swiper.autoplay.stop();
    }

    startAutoplay() {
      //console.log('startAutoplay', this.swiper.params.autoplay);
      if (!this.swiper.params.autoplay.enabled) {
        this.swiper.params.autoplay = {
          enabled: true,
          stopOnLastSlide: false,
          waitForTransition: true,
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: this.reverse
        };
        this.swiper.autoplay.start();
        return;
      }

      const distance = this.swiper.width * this.swiper.activeIndex + this.swiper.getTranslate();
      this.duration = (distance !== 0)?this.duration:0;

      this.startFlag = true;
      this.swiper.slideTo(this.swiper.activeIndex, this.duration);
    }

    setSlide(play) {
      const opt = {
        modules: [Autoplay],
        init: false,
        loop: true,
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 8000,
        breakpoints: {
          [BREAKPOINTS.desktop]: {
            spaceBetween: 8,
            speed: 10000,
          }
        }
      };
      if (play) {
        opt.autoplay = {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: this.reverse
        };
      }
      this.swiper = new Swiper(this.wrap, opt);

      this.swiper.on('transitionEnd', () => {
        if (this.startFlag) {
          this.startFlag = false;
          this.swiper.autoplay.start();
        }
      });

      this.swiper.init();
    }
  }

  // class Slider //========//
  class SliderWrap {
    constructor(wrap) {
      this.wrap = wrap;
      this.sliders = [];
      this.play = true;
      this.motion_btn = this.wrap.querySelector('.c-motionBtn__btn');

      this.wrap.querySelectorAll('.page-top__mv__slider__rl').forEach((elm) => {
        this.sliders.push(new Slider(elm, false));
      });
      this.wrap.querySelectorAll('.page-top__mv__slider__lr').forEach((elm) => {
        this.sliders.push(new Slider(elm, true));
      });

      this.motion_btn.addEventListener('click', (elm) => {
        if (this.play) {
          for (let i = 0; i < this.sliders.length; i++) {
            this.sliders[i].stopAutoplay();
          }
          if (typeof window.pauseSymbolAnimation === 'function') {
            window.pauseSymbolAnimation(); // シンボルアニメーションを停止
          }
        } else {
          for (let i = 0; i < this.sliders.length; i++) {
            this.sliders[i].startAutoplay();
          }
          if (typeof window.resumeSymbolAnimation === 'function') {
            window.resumeSymbolAnimation(); // シンボルアニメーションを再生
          }
        }
        this.play = !this.play;
        this.motionBtnState();
      });      
    }

    // ボタンの状態変更
    motionBtnState() {
      let label;
      if (this.play) {
        // 再生中
        this.motion_btn.classList.remove('is-pause');
        label = '停止';
      } else {
        // 停止中
        this.motion_btn.classList.add('is-pause');
        label = '再生';
      }
      this.motion_btn.setAttribute('aria-label', label);
    }

    resize() {
      //console.log('wrap resize');
      //this.play = true;
      for (let i = 0; i < this.sliders.length; i++) {
        this.sliders[i].resize(this.play);
      }
    }
  }

  //========//

  // init //--------//
  const wraps = [];
  document.querySelectorAll('.page-top__mv__slider').forEach((wrap) => {
    wraps.push(new SliderWrap(wrap));
  });

  // window resize //--------//
  function resizeFunc() {
    //console.log('resizeFunc');
    for (let i = 0; i < wraps.length; i++) {
      wraps[i].resize();
    }
  }

  let resize_timer = false;
  window.addEventListener('resize', () => {
    if (resize_timer !== false) {
        clearTimeout(resize_timer);
    }
    resize_timer = setTimeout(function() {
      resizeFunc();
    }, 200);
  });
  resizeFunc();
})();